export const GEM_LANG_COOKIE_NAME = "__gpLanguage";
